import type { VehicleDetection, VehicleGroup } from "./client-messages/vehicles";

export interface VehicleFilters {
  selectedCameras: Record<string, string[]>;
  types: string[];
  startDate: string;
  endDate: string;
  plateText: string;
  description: string;
  make: string;
  model: string;
  color: string;
  loadStatuses: string[];
  attributes: Record<string, unknown>;
  limit: number;
}

export interface SimilarFields {
  plateText?: string;
  make?: string;
  model?: string;
  color?: string;
  loadStatus?: string;
  types?: string[];
  attributes?: Record<string, unknown>;
}

export type TimelineEntry =
  | { kind: "single"; vehicle: VehicleDetection }
  | { kind: "cluster"; plate: string; vehicles: VehicleDetection[] }
  | { kind: "group"; group: VehicleGroup };
